angular.module('app.home.homeResolverService', [])
  .factory('app.home.homeResolverService', [
    '$state', 'currentUser',
    /**
     * @param $state
     * @param {CurrentUserService} currentUser
     * @returns {{resolve: app.home.homeResolverService.resolve}}
     */
    function ($state, currentUser) {
      'use strict';

      function getStrategy() {
        if (isAdmin(currentUser.data)) {
          return strategy.default;
        }
        if (isPassHolder(currentUser.data)) {
          return strategy.default;
        }
        if (hasActiveSubscription(currentUser.data)) {
          return strategy.currentSubscriber;
        }
        if (currentUser.hasAccessPass()) {
          // We'll treat users witha access passes as though they are subscribers
          return strategy.currentSubscriber;
        }
        if (neverHadASubscription(currentUser.data)) {
          return strategy.newSubscriber;
        }
        if (formerSubscriber(currentUser.data)) {
          return strategy.formerSubscriber;
        }

        return strategy.default;

      }

      function isAdmin(user) {
        return user.is_admin;
      }

      function isPassHolder(user) {
        return user.access && user.access.length;
      }

      function hasActiveSubscription(user) {
        let hasActiveSubscription = false;
        if (user.subscriptions && user.subscriptions.recurly) {
          _.forEach(user.subscriptions.recurly, (sub) => {
            if (!sub.paused && !sub.is_future) {
              hasActiveSubscription = true;
            }
          });
        }
        return hasActiveSubscription;
      }

      function neverHadASubscription(user) {
        return !user.subscriptions ||
          !Array.isArray(user.subscriptions) ||
          user.subscriptions.length == 0;
      }

      function formerSubscriber(user) {
        return user.last_expired_subscription;
      }

      let strategy = {
        newSubscriber: function () {
          $state.go('app.home.subscribeNow');
        },
        formerSubscriber: function () {
          $state.go('app.pricing');
        },
        failedPayment: function () {
          $state.go('app.pricing');
        },
        currentSubscriber: function () {
          $state.go('app.schedule');
        },
        adminUser: function () {
          $state.go('app.schedule');
        },
        default: function () {
          $state.go('app.schedule');
        }
      };

      return {
        resolve: function () {
          let homeStrategy = getStrategy();
          homeStrategy();
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/home/homeResolverService.js